import {createContext} from 'react';

const ReportParametersContext = createContext(null);

export default ReportParametersContext;
